













import Vue from 'vue'
import style from './style.module.scss'

import { DefaultListModel } from '../types'

export default Vue.extend({
    name: 'default-list',
    components: {

    },
    props: {
        list: Array as () => DefaultListModel[]
    },
    data() {
        return {
            s: style
        }
    },
    mounted() {
        this.$parent.$on('up',  this.up);
        this.$parent.$on('down',  this.down);
    },
    methods: {
        up() {
            console.log('up');
        },
        down() {

            console.log('down');

        },
        selectHandler(item: DefaultListModel) {
            this.$parent.$emit('select-from-list', item);
            this.list.find((item) => item.Selected ? item.Selected = false : false);

            item.Selected = true;
        },
    }
})
